var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id-scan-fv0k23rokmsdo)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.667 18.181c.836 0 1.515-.678 1.515-1.515v-2.424a.909.909 0 1 1 1.818 0v2.424A3.333 3.333 0 0 1 16.667 20h-2.425a.91.91 0 0 1 0-1.819zm0-16.363c.836 0 1.515.679 1.515 1.515v2.425a.91.91 0 1 0 1.818 0V3.333A3.333 3.333 0 0 0 16.667 0h-2.425a.91.91 0 1 0 0 1.818zM3.333 18.181a1.515 1.515 0 0 1-1.515-1.515v-2.424a.909.909 0 1 0-1.818 0v2.424A3.333 3.333 0 0 0 3.333 20h2.425a.91.91 0 0 0 0-1.819zm0-16.363c-.836 0-1.515.679-1.515 1.515v2.425a.91.91 0 0 1-1.818 0V3.333A3.333 3.333 0 0 1 3.333 0h2.425a.91.91 0 0 1 0 1.818zM20 10c0 .46-.344.834-.77.834H.77C.343 10.834 0 10.46 0 10s.344-.833.77-.833h18.46c.426 0 .77.373.77.833"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id-scan-fv0k23rokmsdo"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/scan-icon.15982412c11dbc391196a2e25aa38805.svg";
export { ForwardRef as ReactComponent };